<template>
  <MediaWord type="video" />
</template>

<script>
import MediaWord from '../components/media/MediaWord.vue'

export default {
  name: 'VideoWord',
  components: { MediaWord }
}
</script>
